import { Route } from '@angular/router';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { AuthGuard } from '@core/guard/auth.guard';
import { PermissionGuard } from '@core/guard/permission.guard';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { Page404Component } from './authentication/page404/page404.component';
import { AppHomeGuard } from '@core/guard/app-home.guard';

export const APP_ROUTE: Route[] = [

  // 🔹 REDIRECT INICIAL
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AppHomeGuard],
    component: Page404Component,
  },

  // 🔹 RUTAS PRIVADAS (requieren login)
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [PermissionGuard],
    children: [
      {
        path: 'ai',
        loadChildren: () =>
          import('./ai/ai.routes').then((m) => m.AI_ROUTE),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./admin/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTE),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.routes').then((m) => m.ADMIN_ROUTE),
      },
      {
        path: 'doctor',
        loadChildren: () =>
          import('./doctor/doctor.routes').then((m) => m.DOCTOR_ROUTE),
      },
      {
        path: 'patient',
        loadChildren: () =>
          import('./patient/patient.routes').then((m) => m.PATIENT_ROUTE),
      },
      {
        path: 'extra-pages',
        loadChildren: () =>
          import('./extra-pages/extra-pages.routes').then(
            (m) => m.EXTRA_PAGES_ROUTE
          ),
      },
      {
        path: 'config',
        loadChildren: () =>
          import('./config/config.routes').then(
            (m) => m.CONFIG_ROUTES
          ),
      },
      {
        path: 'organization',
        loadChildren: () =>
          import('./organization/client.routes').then(
            (m) => m.CLIENT_ROUTE
          ),
      },
      {
        path: 'attendance',
        loadChildren: () =>
          import('./attendances/attendance.routes').then(
            (m) => m.ATTENDANCE_ROUTE
          ),
      },
      {
        path: 'devices',
        loadChildren: () =>
          import('./devices/device.routes').then(
            (m) => m.DEVICE_ROUTE
          ),
      },
      {
        path: 'multilevel',
        loadChildren: () =>
          import('./multilevel/multilevel.routes').then(
            (m) => m.MULTILEVEL_ROUTE
          ),
      },
    ],
  },

  // 🔹 RUTAS PÚBLICAS (login, etc.)
  {
    path: 'authentication',
    component: AuthLayoutComponent,
    loadChildren: () =>
      import('./authentication/auth.routes').then((m) => m.AUTH_ROUTE),
  },

  // 🔹 404
  { path: '**', component: Page404Component },
];
